import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const addressRequest = createRequest(constants.address);
export const addressSuccess = createSuccess(constants.address);
export const addressFailure = createFailure(constants.address);

export const updateAddressRequest = createRequest(constants.updateAddress);
export const updateAddressSuccess = createSuccess(constants.updateAddress);
export const updateAddressFailure = createFailure(constants.updateAddress);

export const requestAddress = addressRequest;
export const updateAddress = updateAddressRequest;
